import { submit } from '../../quote-editor/actions';
import { connectEditor } from '../../quote-editor/connect-editor';
import ProjectQuoteEditor from './ProjectQuoteEditor';

export default connectEditor(
  ({ quote }) => ({
    model: quote,
  }),
  {
    onSubmit: event => {
      event.preventDefault();
      return submit();
    },
  },
)(ProjectQuoteEditor);
